/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a metadata of an Order Attachment (a binary file linked to an Order)
 * @export
 * @interface SAPOrderAttachment
 */
export interface SAPOrderAttachment {
    /**
     * Attachment Id which together with the Order code can be used to obtain content of the file
     * @type {string}
     * @memberof SAPOrderAttachment
     */
    sapAttachmentId?: string;
    /**
     * Attachment File Name
     * @type {string}
     * @memberof SAPOrderAttachment
     */
    sapFileName?: string;
}

/**
 * Check if a given object implements the SAPOrderAttachment interface.
 */
export function instanceOfSAPOrderAttachment(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SAPOrderAttachmentFromJSON(json: any): SAPOrderAttachment {
    return SAPOrderAttachmentFromJSONTyped(json, false);
}

export function SAPOrderAttachmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPOrderAttachment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sapAttachmentId': !exists(json, 'sapAttachmentId') ? undefined : json['sapAttachmentId'],
        'sapFileName': !exists(json, 'sapFileName') ? undefined : json['sapFileName'],
    };
}

export function SAPOrderAttachmentToJSON(value?: SAPOrderAttachment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sapAttachmentId': value.sapAttachmentId,
        'sapFileName': value.sapFileName,
    };
}

